import {BrowserRouter, Route} from "react-router";
import Layout from "@/layout/layout";
import { Provider } from 'react-redux'
import {store} from "@/store";
import {SentryRoutes} from "@/instrument.ts";
import {SClassTestListPage} from "@/pages/sclass-test/SClassTestListPage.tsx";
import {lazy, Suspense} from "react";

const OverviewPage = lazy(() => import("@/pages/overview/over-view").then((module) => ({default: module.OverviewPage})));
const LoginPage = lazy(() => import("@/pages/auth/LoginPage"));
const RegisterPage = lazy(() => import("@/pages/auth/RegisterPage"));
const ResetPasswordPage = lazy(() => import("@/pages/auth/ResetPasswordPage"));
const Extensions = lazy(() => import("@/pages/extensions").then((module) => ({default: module.Extensions})));
const Genaral = lazy(() => import("@/pages/plan-not-access/genaral.tsx").then((module) => ({default: module.Genaral})));
const CustomerFilePage = lazy(() => import("@/pages/system-account").then((module) => ({default: module.CustomerFilePage})));
const SystemPaymentMethod = lazy(() => import("@/pages/system-payment-method").then((module) => ({default: module.SystemPaymentMethod})));
const FeatureRequestPage = lazy(() => import("@/pages/feature-request"));
const ServiceRequestPage = lazy(() => import("@/pages/service-request/ServiceRequestPage").then((module) => ({default: module.ServiceRequestPage})));
const AgentServiceRequestPage = lazy(() => import("@/pages/agent-service-request/AgentServiceRequestPage").then((module) => ({default: module.AgentServiceRequestPage})));
const TicketDashboardPage = lazy(() => import("@/pages/ticket-dashboard/TicketDashboardPage").then((module) => ({default: module.TicketDashboardPage})));
const EventCreatePage = lazy(() => import("@/pages/ticket-event/EventCreatePage").then((module) => ({default: module.EventCreatePage})));
const TicketOrderCreatePage = lazy(() => import("@/pages/ticket-order/TicketOrderCreatePage").then((module) => ({default: module.TicketOrderCreatePage})));
const ActivitySettingsPage = lazy(() => import("@/pages/ticket-activity/ActivitySettingsPage").then((module) => ({default: module.ActivitySettingsPage})));
const ChipUserAssignmentPage = lazy(() => import("@/pages/ticket-chip-assignment/ChipUserAssignmentPage").then((module) => ({default: module.ChipUserAssignmentPage})));
const PersonalMessagePage = lazy(() => import("@/pages/personal-message/PersonalMessagePage.tsx"));
const TranscriptionPage = lazy(() => import("@/pages/transcription/TranscriptionPage.tsx"));
const AudioAnalyzerPage = lazy(() => import("@/pages/audio-analyzer/AudioAnalyzerPage.tsx"));
const TextToSpeechPage = lazy(() => import("@/pages/text-to-speech/TextToSpeechPage.tsx"));
const TextToSpeechDocsPage = lazy(() => import("@/pages/text-to-speech/TextToSpeechDocsPage.tsx"));
const CallQualityPage = lazy(() => import("@/pages/call-quality/CallQualityPage.tsx"));
const CallAnalyticsPage = lazy(() => import("@/pages/call-analytics/CallAnalyticsPage.tsx"));
const AiChatPage = lazy(() => import("@/pages/ai-chat/AiChatPage.tsx"));
const ApiDocsPage = lazy(() => import("@/pages/api-docs/ApiDocsPage.tsx"));
const InboxManagementPage = lazy(() => import("@/pages/inbox-management/InboxManagementPage").then((module) => ({default: module.InboxManagementPage})));
const AnnouncementsAdminPage = lazy(() => import("@/pages/announcements-admin/AnnouncementsAdminPage.tsx"));
const DocumentationListPage = lazy(() => import("@/pages/documentation/DocumentationListPage.tsx"));
const DocumentationEditPage = lazy(() => import("@/pages/documentation/DocumentationEditPage.tsx"));
const PhoneBookImportPage = lazy(() => import("@/pages/phone-book-import/PhoneBookImportPage.tsx"));
const SClassTestEditPage = lazy(() => import("@/pages/sclass-test").then((module) => ({default: module.SClassTestEditPage})));

function App() {

  return (
    <Provider store={store}>
        <BrowserRouter>
            <Suspense fallback={<div className="p-6 text-center">טוען...</div>}>
                <SentryRoutes>
                    <Route errorElement={<YourCustomRootErrorBoundary />}>
                   <Route path="/login" element={<LoginPage />} />
                   <Route path="/register" element={<RegisterPage />} />
                   <Route path="/reset-password" element={<ResetPasswordPage />} />
                   <Route element={<Layout/>}>
                       <Route index element={<OverviewPage />}/>
                       <Route path="extensions/" element={<Extensions/>}/>
                       <Route path="system/account/" element={<CustomerFilePage/>} />
                       <Route path="system/payment-method/" element={<SystemPaymentMethod/>} />
                       <Route path="403/" element={<Genaral/>}/>
                       <Route path="feature-request/" element={<FeatureRequestPage/>}/>
                       <Route path="crm/servicecall/" element={<ServiceRequestPage/>}/>
                       <Route path="crm/servicecall-agent/" element={<AgentServiceRequestPage/>}/>
                       <Route path="ticket/dashboard/" element={<TicketDashboardPage/>}/>
                       <Route path="ticket/event/add/" element={<EventCreatePage/>}/>
                       <Route path="ticket/event/:eventId/edit/" element={<EventCreatePage/>}/>
                       <Route path="ticket/ticketorder/add/" element={<TicketOrderCreatePage/>}/>
                       <Route path="ticket/activity/:activityId/edit/" element={<ActivitySettingsPage/>}/>
                       <Route path="ticket/chip-assignment/" element={<ChipUserAssignmentPage/>}/>
                       <Route path="personal-msg/" element={<PersonalMessagePage/>}/>
                       <Route path="tools/transcription/" element={<TranscriptionPage/>}/>
                       <Route path="tools/audio-analyzer/" element={<AudioAnalyzerPage/>}/>
                       <Route path="tools/text-to-speech/" element={<TextToSpeechPage/>}/>
                       <Route path="tools/text-to-speech/docs/" element={<TextToSpeechDocsPage/>}/>
                       <Route path="tools/call-quality/" element={<CallQualityPage/>}/>
                       <Route path="reports/call-analytics/" element={<CallAnalyticsPage/>}/>
                       <Route path="tools/ai-chat/" element={<AiChatPage/>}/>
                       <Route path="api-docs/" element={<ApiDocsPage/>}/>
                       <Route path="api-docs/:slug/" element={<ApiDocsPage/>}/>
                       <Route path="admin/inbox/" element={<InboxManagementPage/>}/>
                       <Route path="admin/announcements/" element={<AnnouncementsAdminPage/>}/>
                       <Route path="admin/documentation/" element={<DocumentationListPage/>}/>
                       <Route path="admin/documentation/new/" element={<DocumentationEditPage/>}/>
                       <Route path="admin/documentation/:id/edit/" element={<DocumentationEditPage/>}/>
                       <Route path="admin/phone-book/import/" element={<PhoneBookImportPage/>}/>
                       <Route path="sclass-test/" element={<SClassTestListPage/>}/>
                       <Route path="sclass-test/:id/edit/" element={<SClassTestEditPage/>}/>
                   </Route>
                    </Route>
                </SentryRoutes>
            </Suspense>
        </BrowserRouter>
    </Provider>
  )
}

export default App


// error boundary
import { useRouteError } from "react-router";
import * as Sentry from "@sentry/react";
import {useEffect} from "react";
export function YourCustomRootErrorBoundary() {
    const error = useRouteError() as Error;
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);
    return (
        <div>
            <h1>אופס!</h1>
            <p>נראה שיש בעיה במערכת</p>
            <p>אנא נסה שוב מאוחר יותר</p>
        </div>
    );
}
